import script from "./RaffleRecord.vue?vue&type=script&setup=true&lang=ts"
export * from "./RaffleRecord.vue?vue&type=script&setup=true&lang=ts"

import "./RaffleRecord.vue?vue&type=style&index=0&id=3437fd63&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3437fd63"]])

export default __exports__